
function initIsotope(section) {
    var grid = section.querySelector('[data-isotope-grid]');
    if (grid) {
        new Isotope(grid, {
        itemSelector: '.grid-item',
        percentPosition: true,
        layoutMode: 'masonry',
        transitionDuration: 0,
        masonry: {
            columnWidth: '.grid-sizer',
            gutter: parseInt(getComputedStyle(grid).getPropertyValue('--grid-gutter-x')) || 0
        }
        });
    }
}

function imageParallax(selector, options = {}) {
    if (!selector) return;

    const element = document.querySelector(selector);

    if (element && typeof options === 'object' && options !== null) {
        element.style.transform = null;
        element.parentElement?.style.setProperty('overflow', 'hidden');
        element.style.scale = 1.05;

        const r = new Rellax(selector, options);
    }
}

function productCard() {
    const selector = '.product-card';
    const elements = document.querySelectorAll(selector);

    if (elements.length) {
        gsap.utils.toArray(selector).forEach(card => {
            gsap.from(card, {
                opacity: 0,
                y: 20,
                duration: 0.2,
                scrollTrigger: {
                    trigger: card,
                    start: "top 80%", // カードが画面に入るタイミング
                    toggleActions: "play none none none"
                }
            });
        });
    }
}

function init() {
    // TOP FV 画像
    // imageParallax(
    //     '#shopify-section-template--20008652996708__section_Fh7TFQ .custom-section-background img',
    //     {
    //         speed: -2,
    //         center: false,
    //     }
    // );

    imageParallax(
        '.shopify-section:first-child .hero__media-wrapper img',
        {
            speed: -2,
            center: false,
        }
    );

    // TOP フッター前画像
    // imageParallax(
    //     '.image-block--ALzNWZWdxZzVqeG1nO__image_3Tjfaj img',
    //     {
    //         speed: -2,
    //         center: true,
    //     }
    // );
    
    productCard();
}

// 初回ロード
document.addEventListener("DOMContentLoaded", function() {
    init();
    document.querySelectorAll('[data-testid="masonry-grid"]').forEach(initIsotope);
});

// テーマエディタでセクションが再描画されたとき
document.addEventListener("shopify:section:load", function(event) {
    init();
    initIsotope(event.target);
});